export const addNoScroll = () => {
  document.body.classList.add('scroll-disabled');
};

export const removeNoScroll = () => {
  document.body.classList.remove('scroll-disabled');
};